import BaseSerializer from './Base';
import TileWMS from 'ol/source/TileWMS';
import {get as getProjection} from 'ol/proj';
import {toSize} from 'ol/size';
import {DEFAULT_WMS_VERSION} from 'ol/source/common';

class TileWMSSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = TileWMS;
    }

    serialize(layer, source, resolution, map) {
        this.validateSource(source);
        let styles = source.getParams().STYLES;
        let stylesArray = styles ? styles.split(',') : [''];
        let params = source.getParams();
        if(Object.keys(params).includes('CQL_FILTER')){
            if(!params.CQL_FILTER){
                delete params.CQL_FILTER;
            }
        }

        let tileSize = [256, 256];
        let tileGrid = source.getTileGrid();
        if (!tileGrid) {
            const projectionObj = source.getProjection() || map.getView().getProjection(); //getProjection((params.CRS ? params.CRS : params.SRS).toUpperCase()) ;
            tileGrid = source.getTileGridForProjection(projectionObj);
            if (tileGrid) {
                tileSize = toSize(tileGrid.getTileSize());
            }
        }
        let serialized = {
            baseURL: source.getUrls() ? source.getUrls()[0] : window.location.href.split(/[?#]/)[0].replace(/^\/|\/$/g, ''),
            customParams: Object.keys(params).filter(key => !['FORMAT', 'LAYERS', 'VERSION', 'SERVICE', 'SRS', 'CRS'].includes(key.toUpperCase()))
                            .reduce((obj, key) => {obj[key] = params[key];return obj;}, {}),
            layers: [
                params.LAYERS
            ],
            imageFormat: params.FORMAT,
            version: params.VERSION ? params.VERSION : DEFAULT_WMS_VERSION,
            opacity: layer.getOpacity(),
            styles: stylesArray,
            type: params.TILED ? 'tiledwms' : 'WMS',
            tileSize: params.TILED ? tileSize : null,
            legend_url:layer.get('legend_url'),
            name:layer.get("name")
        };
        return serialized;
    }
};

export default TileWMSSerializer;